import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";
import { Typography } from "../../../../common/components";
import { Modal } from "../../../../common/components/Modal";
import { STEPS } from "../../constants";
import { useSetUpSpacesStore } from "../../store";
import { DialogStepper } from "../DialogStepper";

const SetUpCompany = () => {
    const { company, toggleVisibility, setCompany, setStep } =
        useSetUpSpacesStore();

    const { t } = useTranslation(["common", "setUpSpaces"]);

    const isEmptyValue = !company?.trim();

    const handleClickNext = () => {
        if (isEmptyValue) {
            return;
        }

        setStep(STEPS.SET_LOCATION);
    };

    return (
        <Modal
            title={t("setUpSpaces:company.title") || ""}
            isOpen
            hasOkButton
            isOkButtonDisabled={isEmptyValue}
            okText={t("common:next") || ""}
            onClickClose={toggleVisibility}
            onClickOk={handleClickNext}
            className="max-w-full"
        >
            <div className="flex flex-col gap-4">
                <DialogStepper activeStep={STEPS.SET_COMPANY} />
                <Typography>{t("setUpSpaces:company.question")}</Typography>
                <div>
                    <label>{t("common:name")}*</label>
                    <InputText
                        className="w-full"
                        value={company}
                        onChange={(e) => {
                            setCompany(e.target.value);
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default SetUpCompany;
